<template>
  <div class="page">
		<PageHeader>
			Настройка резерва
		</PageHeader>

		<div class="content">
			<div class="block">
				<div class="header">
					<div class="title">Добавить отзыв</div>
				</div>
				<div class="content">
					<form @submit.prevent="addReview()">
						<input type="text" placeholder="Ваше полное имя" v-model="form.fullname" required>
						<textarea placeholder="Ваше сообщение" rows="8" cols="80" v-model="form.description" required></textarea>
						<button>Добавить</button>
					</form>
				</div>
			</div>
			<!--  -->
			<div class="block" v-for="review in reviews">
				<div class="header">
					<div class="close" style="color: red;" @click.prevent="removeReview(review._id)">Удалить</div>
					<div class="title">{{ review.fullname }}</div>
				</div>
				<div class="content">
					<p>{{ review.description }}</p>
					<p style="font-size: 14px; color: gray;">Опубликовано: {{ getDateTime(review.date) }}</p>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getReviews, addReview, deleteReview } from '@/api'
import PageHeader from "../../ui/PageHeader.vue";
//
export default {
  components: { PageHeader },
  name: 'Reviews',

	data: () => ({
		reviews: false,
		form: {
			fullname: '',
			description: ''
		}
	}),

	mounted () {
		this.getReviews()
	},

	methods: {
		getDateTime (datetime) {
			let date = new Date(datetime)
			//
			const hours = date.getHours()
			const minutes = date.getMinutes()
			//
			const day = date.getDate()
			const month = date.getMonth() + 1
			const year = date.getFullYear()
			//
			return `${day}.${month < 10 ? '0' + month : month}.${year} в ${hours}:${minutes}`
		},

		getReviews () {
			getReviews ()
				.then(response => {
					this.reviews = response.data.result
				})
		},

		removeReview (id) {
			deleteReview (id)
				.then(() => this.getReviews())
		},

		addReview () {
			addReview(this.form)
				.then(() => this.getReviews())
		}
	}
}
</script>

<style scoped>
.item {
	display: block;
	margin: 5px 0;
}

.item > label,
.item > input {
	display: inline-block;
}

.item > textarea {
	display: block;
	margin-top: 5px;
	padding: 7px;
	font-family: verdana;
	width: 95%;
	min-height: 250px;

}
</style>



// WEBPACK FOOTER //
// src/components/pages/Reviews/index.vue